import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.styl';

const windowExists = typeof window !== 'undefined';
const ENV = windowExists ? window.env.NODE_ENV : process.env.NODE_ENV;

function EditLink({ contentfulId, githubEditLink, trackData }) {
  let content;

  if (contentfulId && ENV !== 'production') {
    content = <React.Fragment>
      <span>Any suggestion or typo? </span>
      <a
        className={styles.editLink}
        href={`https://app.contentful.com/spaces/cdy7uua7fh8z/entries/${contentfulId}`}
        onClick={() => trackData('click:edit-contentful')}
        target="_blank"
        rel="noreferrer noopener nofollow"
      >
        Edit on Contentful
      </a>
    </React.Fragment>
  } else if (githubEditLink) {
    content = <React.Fragment>
      <span>Any suggestion or typo? </span>
      <a
        className={styles.editLink}
        href={githubEditLink}
        onClick={() => trackData('click:edit-github')}
        target="_blank"
        rel="noreferrer noopener nofollow"
      >
        Edit on GitHub
      </a>
    </React.Fragment>
  }

  return (
    <div className={styles.suggestions}>
      {content}
    </div>
  );
}

EditLink.propTypes = {
  contentfulId: PropTypes.string,
  githubEditLink: PropTypes.string,
  trackData: PropTypes.func.isRequired
};

export default EditLink;
